import { useBaseAppId } from "../../navigation/baseApps";
import { baseAppsApi } from "../../services/api/baseApps";
import FileListTabPage from "../files/FileListTabPage";

export default function BaseAppFilesTabPage() {
    return <FileListTabPage api={baseAppsApi.files} ownerId={useBaseAppId()} />;
}
